import { useEffect, useState } from "react";

const useConvertImageToBase64 = (url) => {
  const [base64, setBase64] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) return;

    let isMounted = true;

    const convert = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Cache-Control": "no-cache",
          },
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Image fetch failed");
        }

        const blob = await response.blob();

        const reader = new FileReader();

        reader.onloadend = () => {
          if (isMounted) {
            setBase64(reader.result);
            setLoading(false);
          }
        };

        reader.onerror = () => {
          if (isMounted) {
            setError("Base64 conversion failed");
            setLoading(false);
          }
        };

        reader.readAsDataURL(blob);
      } catch (err) {
        if (isMounted) {
          setError(err.message);
          setLoading(false);
        }
      }
    };

    convert();

    return () => {
      isMounted = false;
    };
  }, [url]);

  return { base64, loading, error };
};

export default useConvertImageToBase64;